export default function ApplicationQuestions() {
  const questions = [
    {
      id: 1,
      question:
        "1. 잇타에 지원하게 된 계기를 본인의 꿈과 연결지어 설명해 주세요. (공백 포함 500자 이내)",
      answer:
        "안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까"
    },
    {
      id: 2,
      question:
        "2. 잇타에 지원하게 된 계기를 본인의 꿈과 연결지어 설명해 주세요. (공백 포함 500자 이내)",
      answer:
        "안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까"
    },
    {
      id: 3,
      question:
        "3. 잇타에 지원하게 된 계기를 본인의 꿈과 연결지어 설명해 주세요. (공백 포함 500자 이내)",
      answer:
        "안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까 저는 성신여대 서비스디자인공학과 전공 22살 김민지입니다. 저는 ~..안녕하십니까"
    }
  ];
  return (
    <div>
      <p className="mb-2 text-gray-500 text-subheadline text-left">지원 문항</p>
      {questions.map((item) => (
        <div
          key={item.id}
          className="mb-6 py-6 px-4 w-full h-auto bg-main-300 rounded-lg "
        >
          <p className="mb-5 text-headline text-gray-1100 text-left">
            {item.question}
          </p>
          <div className="px-5 py-5 bg-white-100 rounded-lg border border-gray-200 text-gray-1000">
            {item.answer}
          </div>
        </div>
      ))}
    </div>
  );
}
